import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { symbolInitializationGuard } from './guards/symbol-initialization.guard';
import { AuthGuard } from './guards/auth.guard';
import { NotFoundComponent } from './helper/no-found.component';

const routes: Routes = [
    {
        path: 'user',
        loadChildren: () =>
            import('./auth/auth.module').then(mod => mod.AuthModule)
    },
    {
        path: 'dashboard',
		canActivate: [AuthGuard, symbolInitializationGuard],
        loadChildren: () =>
            import('./dashboard/dashboard.module').then(mod => mod.DashboardModule)
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'user/login'
    },
	{ path: '**', component: NotFoundComponent },

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
